<script setup lang="ts">
import { ref } from 'vue';
import { CookieRestClient } from '@idem/common/rest/cookie-rest-client';
import FeatureFlag from '@frontend/common/feature-flag.vue';
import { textosAsistenteDeCarga as textos } from '@frontend/actividad/textos-asistente-de-carga';

const planilla = ref<File>();
const resultado = ref<{ cargadas: string[]; rechazadas: string[] }>();
const error = ref('');
const cargando = ref(false);

function elegirPlanilla(evento: Event) {
  planilla.value = (evento.target as HTMLInputElement).files?.[0];
}

async function cargar() {
  cargando.value = true;
  error.value = '';
  try {
    const datos = new FormData();
    datos.append('planilla', planilla.value as File);
    resultado.value = await new CookieRestClient().post('super/actividades/planilla', datos);
  } catch {
    error.value = textos.error;
  } finally {
    cargando.value = false;
  }
}
</script>

<template>
  <feature-flag name="asistente-de-carga">
    <template #funcionalidadHabilitada>
      <section class="mx-auto max-w-4xl px-4 py-8">
        <h1 class="mb-6 text-3xl font-bold">{{ textos.titulo }}</h1>
        <label class="block text-sm font-medium text-gray-700">
          {{ textos.etiquetaPlanilla }}
          <input type="file" accept=".xlsx" data-testid="planilla" class="mt-1 block w-full text-sm" @change="elegirPlanilla" />
        </label>
        <button
          data-testid="cargar"
          :disabled="cargando || !planilla"
          class="mt-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
          @click="cargar"
        >
          {{ cargando ? textos.cargando : textos.cargar }}
        </button>
        <p v-if="error" class="mt-4 text-sm text-red-600">{{ error }}</p>
        <template v-if="resultado">
          <h2 class="mt-6 mb-1 text-sm font-medium text-gray-700">{{ textos.etiquetaCargadas }}</h2>
          <ul class="list-disc pl-6 text-sm">
            <li v-for="nombre in resultado.cargadas" :key="nombre" data-testid="cargada">{{ nombre }}</li>
          </ul>
          <template v-if="resultado.rechazadas.length">
            <h2 class="mt-6 mb-1 text-sm font-medium text-red-700">{{ textos.etiquetaRechazadas }}</h2>
            <ul class="list-disc pl-6 text-sm">
              <li v-for="nombre in resultado.rechazadas" :key="nombre" data-testid="rechazada">{{ nombre }}</li>
            </ul>
          </template>
        </template>
      </section>
    </template>
  </feature-flag>
</template>
